<template src='./productAdd.html'></template>
<script>
export default {
  data: function() {
    return {
      add: this.$route.params.add,
      productData: {}
    };
  },
  methods: {
    clearEntries: function() {
      (this.productData.code = null), (this.productData.name = null), (this.productData.description = null);
    },
    goToListPage: function() {
      this.$router.push({ name: "Product" });
    },
    addProduct: function() {
      if (this.productData.code && this.productData.name && this.productData.description) {
        this.productData.IsDeleted = false
        if (this.add) {
          this.$store
            .dispatch("product/addProduct", this.productData)
            .then(() => {
              this.goToListPage();
              this.clearEntries();
            });
        } else {
          this.$store
            .dispatch("product/updateProduct", this.productData)
            .then(() => {
              this.goToListPage();
              this.clearEntries();
            });
        }
    }
    }
  },
  beforeMount() {
    if (!this.$route.params.add) {
      this.productData = this.$store.getters["product/product"];
    }
  }
};
</script>